import { useState, useEffect, useCallback } from "react";
import { AxiosError } from "axios";

// API
import { GetIsFavourite, AddOrDeleteFavourite } from "../../../../Api/Favourite";

// Models
import { AuthUser } from "../../../../Models/DTOs/AuthUser";

/**
 * Use either:
 *   useFavoriteSeriesStatus(seriesId, authUser)
 * or
 *   useFavoriteSeriesStatus(seriesId, authUser.id)
 */
export default function useFavoriteSeriesStatus(
    seriesId: number,
    user: AuthUser | string | null | undefined
) {
    const
        userId = typeof user === "string" ? user : user?.id,
        [isFav, setIsFav] = useState(false),
        [loading, setLoading] = useState(true);

    // Fetch initial favourite state
    useEffect(() => {
        if (!seriesId || !userId) return;
        const ac = new AbortController();
        setLoading(true);

        GetIsFavourite(seriesId, userId, true, ac)
            .then((res) => {
                if (!(res instanceof AxiosError)) {
                    setIsFav(res);
                }
            })
            .finally(() => setLoading(false));

        return () => ac.abort();
    }, [seriesId, userId]);

    // Toggle favourite on/off
    const toggle = useCallback(async () => {
        if (!seriesId || !userId) return;
        const ac = new AbortController();
        setLoading(true);

        const result = await AddOrDeleteFavourite(seriesId, userId, true, ac);

        // API returns a string on success, or an AxiosError
        if (!(result instanceof AxiosError)) {
            setIsFav((prev) => !prev);
        }

        setLoading(false);
    }, [seriesId, userId]);

    return { isFav, loading, toggle };
}
